import styled from 'styled-components';

import { VizTheme } from './theme';

// Constants representing height of tooltip container displayed outside chart. Used in styles as well
// as plot height computation.
export const tooltipOutsideChartContainerHeightRaw = 16;
const tooltipOutsideChartContainerHeight = `${tooltipOutsideChartContainerHeightRaw}px`;

export const StyledTooltipOutsideChartWrapper = styled.div`
    height: ${tooltipOutsideChartContainerHeight};
    margin-left: 6px; // Align tooltip container with chart title
`;

export const StyledTimeseriesChartContainer = styled.div<{
    height: number | string;
    width: string | number;
}>`
    height: ${(props): string => (typeof props.height === 'number' ? `${props.height}px` : props.height)};
    width: ${(props): string => (typeof props.width === 'number' ? `${props.width}px` : props.width)};
`;

export const StyledTimeSeriesChart = styled.div<{
    flexDirection: string;
    theme: VizTheme;
    width: string | number;
}>`
    ${({ flexDirection, theme, width }): string => `
        flex-direction: ${flexDirection};
        width: ${typeof width === 'number' ? `${width}px` : `${width}`};
        --tooltip-line-stroke: ${theme.tooltip.lineStroke};
    `}
    display: flex;
    flex: 1;
    font-family: ${({ theme }): string => theme.fontFamily};
    position: relative;
    height: 100%;

    .olly-viz-nonInteractive {
        position: absolute;
        pointer-events: none;
    }

    .olly-viz-interactive {
        position: absolute;
        pointer-events: none;
    }

    .olly-viz-cursor {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .olly-viz-event-annotation:hover {
        scale: 1.1;
    }

    /* Overwrite uplot style */
    .uplot {
        position: relative;
    }

    /* Override cursor pt margins to center markers */
    .u-over .u-cursor-pt {
        margin-left: -3px !important;
        margin-top: -3.5px !important;
        z-index: 1 !important;
    }

    .u-select {
        background: rgba(0, 0, 0, 0.3);
    }

    .u-hz .u-cursor-x {
        border-right: 1px solid var(--tooltip-line-stroke);
    }

    /* Tooltip styling - ensure tooltip appears above cursor points */
    .olly-viz-tooltip-line {
        z-index: 10;
        pointer-events: none;
    }

    .olly-viz-tooltip-body {
        z-index: 100;
    }

    /* Pin related style */
    ${({ theme }): string => `
        --pin-dot-fill: ${theme.pin.dotFill};
        --pin-line-stroke: ${theme.pin.lineStroke};
        --pin-icon-stroke: ${theme.pin.iconStroke};
    `}

    .pin {
        overflow: visible !important;
        pointer-events: none;

        .pin-line {
            stroke: var(--pin-line-stroke);
            stroke-width: 1px;
        }

        .pin-dot-outer {
            fill: var(--pin-dot-fill);
            opacity: 0.4;
        }

        .pin-dot-inner {
            fill: var(--pin-dot-fill);
            cursor: pointer;
            pointer-events: all;

            &.disabled {
                cursor: crosshair;
            }
        }

        .pin-close-line {
            stroke: var(--pin-icon-stroke);
            stroke-width: 1px;
        }
    }
`;
